[
  {
    "code": "HU-BA",
    "name": "Baranya"
  },
  {
    "code": "HU-BZ",
    "name": "Borsod-Abaúj-Zemplén"
  },
  {
    "code": "HU-BU",
    "name": "Budapest"
  },
  {
    "code": "HU-BK",
    "name": "Bács-Kiskun"
  },
  {
    "code": "HU-BE",
    "name": "Békés"
  },
  {
    "code": "HU-BC",
    "name": "Békéscsaba"
  },
  {
    "code": "HU-CS",
    "name": "Csongrád"
  },
  {
    "code": "HU-DE",
    "name": "Debrecen"
  },
  {
    "code": "HU-DU",
    "name": "Dunaújváros"
  },
  {
    "code": "HU-EG",
    "name": "Eger"
  },
  {
    "code": "HU-FE",
    "name": "Fejér"
  },
  {
    "code": "HU-GY",
    "name": "Gyor"
  },
  {
    "code": "HU-GS",
    "name": "Gyor-Moson-Sopron"
  },
  {
    "code": "HU-HB",
    "name": "Hajdú-Bihar"
  },
  {
    "code": "HU-HE",
    "name": "Heves"
  },
  {
    "code": "HU-HV",
    "name": "Hódmezovásárhely"
  },
  {
    "code": "HU-JN",
    "name": "Jász-Nagykun-Szolnok"
  },
  {
    "code": "HU-KV",
    "name": "Kaposvár"
  },
  {
    "code": "HU-KM",
    "name": "Kecskemét"
  },
  {
    "code": "HU-KE",
    "name": "Komárom-Esztergom"
  },
  {
    "code": "HU-MI",
    "name": "Miskolc"
  },
  {
    "code": "HU-NK",
    "name": "Nagykanizsa"
  },
  {
    "code": "HU-NY",
    "name": "Nyíregyháza"
  },
  {
    "code": "HU-NO",
    "name": "Nógrád"
  },
  {
    "code": "HU-PE",
    "name": "Pest"
  },
  {
    "code": "HU-PS",
    "name": "Pécs"
  },
  {
    "code": "HU-ST",
    "name": "Salgótarján"
  },
  {
    "code": "HU-SO",
    "name": "Somogy"
  },
  {
    "code": "HU-SN",
    "name": "Sopron"
  },
  {
    "code": "HU-SZ",
    "name": "Szabolcs-Szatmár-Bereg"
  },
  {
    "code": "HU-SD",
    "name": "Szeged"
  },
  {
    "code": "HU-SS",
    "name": "Szekszárd"
  },
  {
    "code": "HU-SK",
    "name": "Szolnok"
  },
  {
    "code": "HU-SH",
    "name": "Szombathely"
  },
  {
    "code": "HU-SF",
    "name": "Székesfehérvár"
  },
  {
    "code": "HU-TB",
    "name": "Tatabánya"
  },
  {
    "code": "HU-TO",
    "name": "Tolna"
  },
  {
    "code": "HU-VA",
    "name": "Vas"
  },
  {
    "code": "HU-VE",
    "name": "Veszprém"
  },
  {
    "code": "HU-VM",
    "name": "Veszprém City"
  },
  {
    "code": "HU-ZA",
    "name": "Zala"
  },
  {
    "code": "HU-ZE",
    "name": "Zalaegerszeg"
  }
]